<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="panel">
                    <div class="panel__header">
                        <h2>
                            <i class="panel__header__icon icons icon-people"></i>
                            <span>{{$t('evaluation_students.title')}}</span>
                        </h2>
                    </div>
                    <div class="panel__body">
                        <evaluation-students-table />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import EvaluationStudentsTable from '@/components/tables/evaluation-students/EvaluationStudentsTable';

    @Component({
        components: {
            EvaluationStudentsTable,
        }
    })
    export default class EvaluationStudents extends Vue {
        name = 'evaluation-students';
    }

    Vue.component('evaluation-students', EvaluationStudents);
</script>



// WEBPACK FOOTER //
// src/pages/EvaluationStudents.vue